import { render } from "./UncheckRegister.vue?vue&type=template&id=66c503fa&ts=true"
import script from "./UncheckRegister.vue?vue&type=script&lang=ts"
export * from "./UncheckRegister.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__